<template src="./index.html"></template>

<script>
import { getdata } from './data.js';
import uploadFileplus from '../../../common/uploadFileplus/index.vue';
import config from '../../../../../configHttp';
import {
	amatTaskinquiryFileImport,
	cfimportCFFile,
	vpimportVPFile,
	costCenterimportCostCenterFile,
	delAmatTask,
	amatTaskdownloadLog,
	amatTaskdownloadOriginalDdocument,
	amatManualAdjustmentImportfileImport,
	reimport
} from '../../../../api/home.js';
export default {
	name: 'FileImport',
	components: {
		uploadFileplus
	},
	data() {
		return {
			/* 搜索栏 */
			searchlist: getdata().searchlist,
			searchdata: getdata().searchdata,
			overlength: 0,
			searchdiag: false,
			/* 搜索栏 */
			/* 表格 */
			pagination: getdata().pagination,
			headData: JSON.parse(localStorage.getItem('CustomImportTaskheadData')) || getdata().headData,
			outlist: JSON.parse(localStorage.getItem('CustomImportTaskoutlist')) || [],
			shaidiag: false,
			tableData: [{}, {}],
			tablekey: 0,
			/* 表格 */
			updiag: false,
			upfile: {},
			Count: 0,
			sort: '',
			order: ''
		};
	},
	mounted() {},
	created() {
		this.searrchForData();
	},
	methods: {
		trigger(txt) {
			if (txt == 'CF') {
				cfimportCFFile().then(res => {
					if (res.data.code == '200') {
						this.$message.success(res.data.data);
						this.searrchForData();
					} else {
						this.$message.error(res.data.message);
					}
				});
			} else if (txt == 'VP') {
				vpimportVPFile().then(res => {
					if (res.data.code == '200') {
						this.$message.success(res.data.data);
						this.searrchForData();
					} else {
						this.$message.error(res.data.message);
					}
				});
			} else if (txt == 'CostCenter') {
				costCenterimportCostCenterFile().then(res => {
					if (res.data.code == '200') {
						this.$message.success(res.data.data);
						this.searrchForData();
					} else {
						this.$message.error(res.data.message);
					}
				});
			}
		},
		//表格筛选
		closeshaidiag() {
			this.shaidiag = false;
		},
		confirmfilter(e) {
			localStorage.setItem('CustomImportTaskoutlist', JSON.stringify(e.nochooselist));
			localStorage.setItem('CustomImportTaskheadData', JSON.stringify(e.chooselist));
			this.headData = e.chooselist;
			this.outlist = e.nochooselist;
			this.shaidiag = false;
			this.$refs.tablebox.dout();
			this.tablekey++;
			this.getCloseoutPageList();
		},
		selectionchange(e) {
			this.Count = e.length;
		},
		//重新导入
		reimport(id) {
			let params = {};
			params.id = id;
			reimport(params).then(res => {
				if (res.data.code == '200') {
					this.$message.success(res.data.message);
					this.searrchForData();
				} else {
					this.$message.error(res.data.message);
				}
			});
		},
		//下载日志文件
		DownloadLog(id) {
			let params = {};
			params.id = id;
			amatTaskdownloadLog(params).then(res => {
				let strData = res.data;
				const T_URL = window.URL.createObjectURL(new Blob([strData]));
				const LINK = document.createElement('a');
				LINK.href = T_URL;
				LINK.setAttribute('download', '日志信息');
				LINK.click();
				window.URL.revokeObjectURL(T_URL);
			});
		},
		//下载源文件
		ScratchFile(data) {
			let params = {};
			params.id = data.id;
			let fileType = data.fileName.split('.');
			if (data.fileName.indexOf('.xlsx') != -1 || data.fileName.indexOf('.xls') != -1) {
				let req = {
					downUrl: config.baseURL + '/backGroundTask/downloadOriginalDdocument?id=' + data.id,
					typeObj: {
						toForm: false,
						fileType: fileType[fileType.length - 1],
						fileName: data.fileName
					}
				};
				this.$downloadcommon(req);
			} else {
				amatTaskdownloadOriginalDdocument(params).then(res => {
					let strData = res.data;
					const T_URL = window.URL.createObjectURL(new Blob([strData]));
					const LINK = document.createElement('a');
					LINK.href = T_URL;
					LINK.setAttribute('download', data.fileName);
					LINK.click();
					window.URL.revokeObjectURL(T_URL);
				});
			}
		},
		//导入
		updiagtk() {
			this.updiag = true;
		},
		//删除
		deleteTCode(id) {
			if (this.$refs.tablebox.getSelectionval().length == 0 && id == '-1') {
				this.$message.error('请选择要删除的数据');
				return;
			}
			this.$showConfirm({
				message: '确认删除?'
			}).then(res => {
				if (res == 'confirm') {
					let params = {};
					if (id != '-1') {
						params.ids = id;
					} else {
						params.ids = this.$refs.tablebox
							.getSelectionval()
							.map(v => v.id)
							.join(',');
					}

					delAmatTask(params).then(res => {
						if (res.data.code == '200') {
							this.$message.success('删除成功');
							this.searrchForData();
						} else {
							this.$message.error(res.data.message);
						}
					});
				}
			});
		},
		searrchForData() {
			let params = {};
			params.criteriaJson = JSON.stringify(this.searchdata);
			params.page = this.pagination.pageNum;
			params.rows = this.pagination.pageSize;
			params.sort = this.sort;
			params.order = this.order;
			amatTaskinquiryFileImport(params).then(res => {
				if (res.data.code == '200') {
					this.tableData = res.data.data;
					this.pagination.total = res.data.count;
				}
			});
		},
		sortchange(data) {
			this.sort = data.prop;
			this.order = data.order == 'ascending' ? 'asc' : 'desc';
			this.searrchForData();
		},
		/* 搜索栏 */
		geOoverLength(e) {
			this.overlength = e;
		},
		submitSearch() {
			this.pagination.pageNum = 1;
			this.pagination.paginationkey++;
			this.searrchForData();
		},
		forUpdateSearch() {
			this.searchdiag = true;
		},
		closeSearch() {
			this.searchdiag = false;
		},
		saveChange(e) {
			this.searchdiag = false;
		},
		/* 搜索栏 */
		/* 表格 */
		currentChange(e) {
			this.pagination.pageNum = e;
			this.searrchForData();
		},
		sizechange(e) {
			this.pagination.pageSize = e;
			this.searrchForData();
		},
		/* 表格 */
		forsubmit(e) {
			if (this.$emptyandnull(this.upfile.upfile)) {
				this.$message.error('请选择要上传的文件');
				return false;
			}
			if (this.upfile.filetype.toLowerCase()!='txt') {
				this.$message.error('请选择txt文件');
				return false;
			}
			let params = {};
			params.uploadFile =[]
			params.uploadFile[0] = this.upfile.upfile
			amatManualAdjustmentImportfileImport(params).then(res => {
				if (res.data.code == '200') {
					this.closeupdiag();
					this.searrchForData();
					this.$message.success('导入成功');
				} else {
					this.$message.error(res.data.message);
				}
			});
		},
		closeupdiag() {
			this.updiag = false;
		},
		getuploadparams(e) {
			this.upfile = e;
		}
	}
};
</script>

<style scoped lang="less">
@import url('./index.less');
</style>
